
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"attribute.unknown.name":"Unknown attribute"},"de":{"attribute.unknown.name":"Unbekanntes Attribut"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();